module.exports = __webpack_public_path__ + "static/img/add1.png";